/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : DELETE USER : STYLES --------------- ++++++++++ */
export default theme =>({
    '@global': {
        '.modalpage' : {
            padding: pxToEm(16),
            maxWidth: pxToEm(540),
            '& > .close':{
                background: 'transparent !important',
                border: 'none !important',
            },
        },
        '.modal': {
            backgroundColor : 'rgba(26, 29, 42, 0.70) !important'
        }
    },
    approvepopup: {
        extend: theme.modal.form,
        maxWidth: pxToEm(480),
        padding: `${pxToEm(8)} ${pxToEm(16)}`,
        '& .name-approvepopup':{
            '& .bodycopy':{
                marginBottom: pxToEm(8),
                textAlign: 'center',
                '& > p' : {
                    fontVariantNumeric : 'lining-nums proportional-nums',
                    fontFamily: 'Work Sans',
                    fontSize: pxToEm(16),
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: pxToEm(22),
                    color : '#061240 !important',
                    marginBottom : pxToEm(0) ,
                }
            }
        },
        '& .name-approvePopupContent' : {
            maxWidth: pxToEm(400),
            width: '100%',
            paddingTop: pxToEm(24),
            paddingBottom: pxToEm(8),
            marginLeft: pxToEm(16),
            '& .name-content' : {
                textAlign: 'center',
                fontVariantNumeric : 'lining-nums proportional-nums',
                fontFamily: 'Work Sans',
                fontSize: pxToEm(16),
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: pxToEm(22),
            }
        },
        '& .name-ctas':{
            marginTop:pxToEm(24),
            gap : pxToEm(16),
            '& .type-action': {
                width: pxToEm(216),
                margin : '0px !important',
            },
            '& .variant-action' : {
                backgroundColor : '#DF1D1D',
            }
        },
    }
});
